// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

export enum LoadingState {
    notStarted,
    started,
    rejected,
    success,
    accepted,
}